module.exports = __webpack_public_path__ + "img/trans-exterior.324ee0b9.png";